// eslint-disable-next-line import/prefer-default-export
export const keyCodes = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  ARROWLEFT: 37,
  ARROWUP: 38,
  ARROWRIGHT: 39,
  ARROWDOWN: 40,
};



// WEBPACK FOOTER //
// ./src/utils/constants.js